import MUIDataTable from "mui-datatables";
import { ThemeProvider } from "@mui/styles";
import ebvTheme from "../theme/ebv";
import { Button, Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import moment from "moment";

function PCNDatatable(props) {

    const options = {
        search: true,
        download: true,
        print: false,
        viewColumns: false,
        filter: false,
        // filterType: "dropdown",
        responsive: "standard",
        tableBodyHeight: "600px",
        width: "100%",
        tableBodyMaxHeight: "",
        // onTableChange: (action, state) => {
        //     console.log(action);
        //     console.dir(state);
        // },
        rowsPerPageOptions: [10, 20, 50, 100],
        rowsPerPage: 100,
        selectableRows: "none",
    };

    const columns = [
        {
            name: "MFR_NAME",
            label: "Supplier",
            options: { filterOptions: { fullWidth: true } },
        },
        {
            name: "PCN_ID",
            label: "Internal ID",
            options: {
                display: false,
                customBodyRender: (value) => (
                    <div>
                        <Typography variant="body2" sx={{ px: 1, mb: 1 }}>{value}</Typography>
                    </div>
                ),
            },
        },
        {
            name: "PCN_MFR_ID",
            label: "PCN ID",
            options: {
                customBodyRender: (value, tableMeta) => (
                    <div>
                        <Typography variant="body2" sx={{ px: 1, mb: 1, fontWeight: "bold" }}>{tableMeta.rowData[2]}</Typography>
                        <Button
                            variant="contained"
                            size="small"
                            color="warning"
                            sx={{}}
                            href={`${process.env.PUBLIC_URL}/${tableMeta.rowData[1]}`}
                            startIcon={<InfoIcon />}
                            title="PCN Details (New Tab)"
                        >Open PCN</Button>
                    </div>
                ),
            },
        },
        {
            name: "PCN_SUBJECT",
            label: "Subject",
        },
        {
            name: "PCN_UDAT",
            label: "Date",
            options: {
                customBodyRender: (value) => (
                    <div>{moment(value).format("LL")}</div>
                ),
            },
        },
    ];

    return (
        <ThemeProvider theme={ebvTheme}>
            <MUIDataTable
                title={"Your results"}
                data={props.pcns}
                columns={columns}
                options={options}
                size={"small"}
                sx={{
                    boxShadow: 0,
                    width: "100%"
                }}
            />
        </ThemeProvider>
    );
}

export default PCNDatatable;
